import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  const heroStats = [
    {
      number: '150+',
      label: 'ENGAGEMENTS'
    },
    {
      number: '100+',
      label: 'PARTNER ORGS'
    },
    {
      number: '98%',
      label: 'SATISFACTION'
    }
  ];

  return (
    <section className="hero-modern">
      <div className="hero-background-modern">
        <div className="hero-gradient-orb hero-gradient-orb-1"></div>
        <div className="hero-gradient-orb hero-gradient-orb-2"></div>
        <div className="hero-grid-pattern"></div>
      </div>
      
      <div className="container">
        <div className="hero-wrapper-modern">
          <div className="hero-content-modern">
            <div className="hero-badge-modern">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>The Digital Peak — Scaled. Secured. Sustained.</span>
            </div>
            
            <h1 className="hero-title-modern">
              Build the ridge your business{' '}
              <span className="hero-title-accent-modern">climbs from</span>
            </h1>

            <p className="hero-description-modern">
              We do not just fix IT—we architect the scale, security, and intelligence modern enterprises need to survive digital transformation. From intelligent automation and zero-trust security to Cloud 3.0 and 24/7 managed operations, CodeRidge is a strategic extension of your leadership team—including our work on flagship products, cloud platforms, and secure user experiences.
            </p>

            <div className="hero-stats-modern">
              {heroStats.map((stat, index) => (
                <div key={index} className="hero-stat-card-modern">
                  <div className="hero-stat-number-modern">{stat.number}</div>
                  <div className="hero-stat-label-modern">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="hero-actions-modern">
              <Link to="/contact" className="btn-hero-primary">
                Book a free infrastructure audit
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
              <Link to="/services" className="btn-hero-secondary">
                Explore services
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M15 3H6C4.89543 3 4 3.89543 4 5V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V8L15 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M15 3V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
              <Link to="/portfolio" className="btn-hero-tertiary">
                Our work
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
            </div>
          </div>

          <div className="hero-visual-modern">
            <div className="hero-image-container-modern">
              <div className="hero-image-glow-modern"></div>
              <div className="hero-image-wrapper-modern">
                <img 
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=1000&fit=crop" 
                  alt="CodeRidge — enterprise automation, security, cloud, and managed operations" 
                  className="hero-image-modern"
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/800x1000/FF6B35/FFFFFF?text=CodeRidge';
                  }}
                />
                <div className="hero-image-overlay-modern"></div>
              </div>
              <div className="hero-accent-shape hero-accent-shape-1"></div>
              <div className="hero-accent-shape hero-accent-shape-2"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
